import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import AboutPage from "./pages/AboutPage";
import RoomsPage from "./pages/RoomsPage";
import RestaurantPage from "./pages/RestaurantPage";
import FamilyRoomPage from "./pages/FamilyRoomPage";
import TripleRoomPage from "./pages/TripleRoomPage";
import TwinRoomPage from "./pages/TwinRoomPage";
import DoubleRoomPage from "./pages/DoubleRoomPage";
import SuitePage from "./pages/SuitePage";
import BookingPolicyPage from "./pages/BookingPolicyPage";
import ContactPage from "./pages/ContactPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import BadRagazPage from "./pages/BadRagazPage";
import BookingPage from "./pages/BookingPage";
import NotFound from "./pages/NotFound";
import WhatsAppButton from "./components/WhatsAppButton";
import { lazy, Suspense } from "react";

const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));

const LazyFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin" />
  </div>
);

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <WhatsAppButton />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/rooms" element={<RoomsPage />} />
          <Route path="/rooms/family" element={<FamilyRoomPage />} />
          <Route path="/rooms/triple" element={<TripleRoomPage />} />
          <Route path="/rooms/twin" element={<TwinRoomPage />} />
          <Route path="/rooms/double" element={<DoubleRoomPage />} />
          <Route path="/rooms/suite" element={<SuitePage />} />
          <Route path="/restaurant" element={<RestaurantPage />} />
          <Route path="/booking-policy" element={<BookingPolicyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/bad-ragaz" element={<BadRagazPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/quelle-admin" element={<Suspense fallback={<LazyFallback />}><AdminLogin /></Suspense>} />
          <Route path="/quelle-admin/dashboard" element={<Suspense fallback={<LazyFallback />}><AdminDashboard /></Suspense>} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
